import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { CODIGO_CENTRUS } from '../../../../app.constants';
import { FuncoPrevidenciaModel } from '../../../shared/models/fundo-previdencia.model';
import { PessoaDadosSimplicadosModel } from '../../../shared/models/pessoa-simplificada.model';
import { SuperavitModel } from '../../../shared/models/superavit.model';
import { PBDCFundoPrevidencialPdf } from '../../../shared/services/documentos-pdf-imprimir/Plano/pbdc/pbdc-fundo-previdencial-pdf';
import { PessoaService } from '../../../shared/services/pessoa.service';
import { StorafeUtil } from '../../../shared/util/storasge.util';
import { PbdcService } from '../service/pbdc.service';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { MessageUtil } from '../../../shared/messages/messageUtil';

@Component({
  selector: 'app-pbdc-fundo-previdencial',
  templateUrl: './pbdc-fundo-previdencial.component.html',
  styleUrls: ['./pbdc-fundo-previdencial.component.css']
})
export class PbdcFundoPrevidencialComponent implements OnInit {

  componentes: any[] = [1];


  fundoPrevidencia: Array<FuncoPrevidenciaModel> = Array<FuncoPrevidenciaModel>();

  superavitModel: Array<SuperavitModel> = new Array<SuperavitModel>();

  pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  cdCentrus: number;
  param: string;


  nrSuperavit = 2;

  @BlockUI() blockUi: NgBlockUI;
  page = 0;
  rows = 14;
  totalRecords = 0;

  linkAtivo = false;
  linkPatronal = false;
  linkPatronalCentrus = false;
  linkAssistido = false;
  linkPatronalAssistido = false;
  tipo = 0;

  verificarPatronalRetorno = false;


  cdCentrusTit: number;

  titulo: string;
  mensagem: string;
  mensagemFooter: string;


  constructor(
    private pbdcService: PbdcService,
    private router: Router,
    private toastrService: ToastrService,
    private pessoaService: PessoaService,
    private authInterceptor: AuthInterceptor,
    private pBDCFundoPrevidencialPdf: PBDCFundoPrevidencialPdf
  ) { }

  ngOnInit() {

    this._gerenciarCodigoIndentificao();
  }

   getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }


  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
      .then(recuperandoObjeto => {

        if (recuperandoObjeto) {
          const novoObjeto = Number(JSON.parse(recuperandoObjeto));
          this.cdCentrus = novoObjeto
          this.param = '/administrativo/operacoesConsultaParticipante';
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
          this.param =  '/cardMenus/cardMenuPlanos';
        }
        this.getPessoasDadosSimplificado();
      })
  }


  async getPessoasDadosSimplificado() {
    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);
      this.validarLinks();
    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }


  async validarLinks() {
    try {
      this.cdCentrusTit = await this.pessoaService.getCdCentrusTitular(this.cdCentrus);
      if (!this.cdCentrusTit) {this.cdCentrusTit = this.cdCentrus};
      this.linkAtivo = await this.pbdcService.getVerificarPatronal(this.cdCentrus, this.cdCentrusTit, 1, this.nrSuperavit);
      this.linkAssistido = await this.pbdcService.getVerificarPatronal(this.cdCentrus, this.cdCentrusTit, 4, this.nrSuperavit)

      if (this.linkAtivo) {
        this.tipo = 1;
      }
      if (this.linkAssistido) {
        this.tipo = 4;
      }

      if (this.tipo === 1 || this.tipo === 4) {
        this.linkPatronal = await this.pbdcService.getVerificarPatronal(this.cdCentrus, this.cdCentrusTit, 2, this.nrSuperavit)
        this.linkPatronalCentrus = await this.pbdcService.getVerificarPatronal(this.cdCentrus, this.cdCentrusTit, 3, this.nrSuperavit)
        this.linkAssistido = await this.pbdcService.getVerificarPatronal(this.cdCentrus, this.cdCentrusTit, 4, this.nrSuperavit)
        this.linkPatronalAssistido = await this.pbdcService.getVerificarPatronal(this.cdCentrus, this.cdCentrusTit, 5, this.nrSuperavit)
      }

      this.selecionamentoTituloTipo();
      this.getPageConsultaSuperavitCentrus();
    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }

  selecionamentoTituloTipo() {
    switch (this.tipo) {
      case 1:
        this.titulo = 'Contribuiçães Pessoais - 2009'
        break;
      case 2:
        this.titulo = 'Patrocinador - 2009'
        break;
      case 3:
        this.titulo = 'Contribuiçães Patronais - 2009'
        break;
      case 4:
        this.titulo = 'Assistido - 2009'
        break;
      case 5:
        this.titulo = 'Patrocinador - 2009'
        break;
      default:
        break;
    }
  }

  paginacao(evento) {
    this.page = evento['page'];
    this.rows = evento['rows'];
    this.getPageConsultaSuperavitCentrus();
  }

  async getPageConsultaSuperavitCentrus() {
    this.blockUi.start('Carregando...');
    try {
      const superavitModelRetorno = await this.pbdcService.getPageConsultaSuperavitCentrus(this.cdCentrus, this.cdCentrusTit, this.tipo, this.nrSuperavit, this.rows, this.page);

      if (superavitModelRetorno['totalElements'] <= 0) {this.voltarForcada()};

      this.totalRecords = superavitModelRetorno['totalElements']

      this.superavitModel = this._configurarInformacoesLista(superavitModelRetorno['content']);

    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    } finally {
      this.blockUi.stop();
    }
  }


  voltarForcada(): void {
     this.router.navigate([this.param], { skipLocationChange: true });
    this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
  }

  private _configurarInformacoesLista(superavit: Array<SuperavitModel>): Array<SuperavitModel> {
    let descOco;
    let dtReferencia;
    return superavit.map((item, index, lista) => {
      const superavitModel = new SuperavitModel();

      descOco = item.dsOcorrencia;
      dtReferencia = '';
      if (descOco === 'SALDO'
        || descOco === 'ATUALIZACAO'
      ) {
        dtReferencia = item.dtReferencia;
      }


      superavitModel.dsOcorrencia = descOco;
      superavitModel.dtReferencia = dtReferencia;
      superavitModel.cdCentrus = item.cdCentrus;
      superavitModel.cdCentrusTit = item.cdCentrusTit;
      superavitModel.tpOcorrencia = item.tpOcorrencia;
      superavitModel.nrParcela = item.nrParcela;
      superavitModel.cdGrupo = item.cdGrupo;
      superavitModel.vlOcor = item.vlOcor;
      superavitModel.vlSaldo = item.vlSaldo;
      superavitModel.noPessoa = item.noPessoa;

      return superavitModel
    });

  }


  carregamentoFooter() {


    if (this.tipo = 1) {
      this.mensagem = '(*) Fundo destinado á cobertura das contribuições devidas pelo participante ao PBDC (art. 62 do Regulamento).';
    }
    if (this.tipo = 2) {
      this.mensagem = '(*) Cota patronal de participante autopatrocinado em suspenso, aguardando decisão da Previc (vide comunicado Centrus nº 2014/14).';
    }
    if (this.tipo = 3) {
      this.mensagem = '(*) Fundo destinado á cobertura das contribuições devidas pela Centrus ao PBDC (art. 71 do Regulamento).';
    }
    if (this.tipo = 4) {
      this.mensagem = '(*) Fundo destinado á concessão de benefício temporário (art. 72 do Regulamento).';
    }
    if (this.tipo = 5) {
      this.mensagem = '(*) Fundo destinado á concessão de contrapartida de benefício temporário devido á Centrus (art. 72 do Regulamento).';
    }

    if (this.linkPatronalCentrus && this.nrSuperavit === 2) {
      this.mensagemFooter = '  Extrato da parcela do fundo previdencial patronal relacionada á Centrus. '
    }

  }


  async imprimirPagina() {
    try {
      const superavitModelRetorno = await this.pbdcService.getConsultaSuperavitCentrus(this.cdCentrus, this.cdCentrusTit, this.tipo, this.nrSuperavit);
      const listaRetorno = this._configurarInformacoesLista(superavitModelRetorno);
      this.pBDCFundoPrevidencialPdf.funcionarios(
        this.titulo,
        this.pessoaDadosSimplicadosModel,
        listaRetorno,
        this.mensagem,
        this.mensagemFooter);
    } catch (error) {
      console.error(error);
    }
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/plano/pbdc-fundo-previdencial/pbdc-fundo-previdencial.component.ts